import { Collapse } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import styled, { css, keyframes } from 'styled-components';
import { DEVICE } from '../../GlobalStyle';


const WIDTH = 400;

export const Container = styled.div<{isExpanded: boolean, responsiveMode: boolean, showChat: boolean}>`
  background-color: #f1f1f1;
  width: ${props => props.isExpanded ? '100%' : `${WIDTH}px`};
  border-radius: ${props => props.isExpanded ? '0' : ` 7px 7px 0 0`};
  cursor: auto;

  @media ${DEVICE.mobile} {
    width: 100%;
    border-radius: 0;
  }

  ${props => props.responsiveMode ? `
    width: ${ props.isExpanded || !props.showChat ? '100%' : `${WIDTH}px`};
    border-radius: 0;

    ${ props.showChat ? `

      border-radius: 0;
      left: unset;
      right: unset;

      ` : ``}
  `: ``}
`;

export const Content = styled.div`
  height: 100%;
`;

export const Pulsing = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
`;

export const StyledCollapse = styled(Collapse)<any>`
  z-index: 10000;
  position: fixed;
  bottom: 0;
  box-shadow: 0 20px 40px 8px rgba(0,0,0,.25);
  animation: ${props => ((props.isMobile || props.responsiveMode) && !props.showChat) ? css`${Pulsing} 1.25s infinite cubic-bezier(0.66, 0, 0, 1)` : ``};

  ${props => props.responsiveMode && !props.showChat ? `
    width: 65px;
    min-height: 65px;
    height: 65px;
    border-radius: 65px;
    bottom: 20px;
    transition: none !important;
    box-shadow: none;
    background-color:red;
  ` : ``}

  @media ${DEVICE.mobile} {
    width: 65px;
    min-height: 65px;
    height: 65px;
    border-radius: 65px;
    bottom: 20px;
    transition: none !important;
    box-shadow: none;

    ${props => props.horizontalPosition === 'center' ? `
      left: unset;
      right: 50%;
      margin: 0 -32.5px 0 auto;
    ` 
    : props.horizontalPosition === 'left' ? `
      left: 20px;
      right: unset;
    `
    : props.horizontalPosition === 'right' ? `
      right: 20px;
      left: unset;
    `
    : props.customPosition?.left ? `
      left: ${props.customPosition.left}px;
      right: unset; 
    `
    : `
      right: ${props.customPosition?.right}px;
      left: unset; 
    `
    };

    ${props => props.showChat ? `
      width: 100vw;
      height: 100vh;
      height: calc(100 * var(--vh));
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      border-radius: 0;
    ` : ``}
  }

  ${props => props.horizontalPosition === 'center' ? `
    left: unset;
    right: 50%;
    margin: 0 -${WIDTH/2}px 0 auto;
  ` 
  : props.horizontalPosition === 'left' ? `
    left: 10px;
    right: unset;
  `
  : props.horizontalPosition === 'right' ? `
    right: 10px;
    left: unset;
  `
  : props.customPosition?.left ? `
    left: ${props.customPosition.left}px;
    right: unset; 
  `
  : `
    right: ${props.customPosition?.right}px;
    left: unset; 
  `
  };

  ${props => props.isExpanded ? `
    width: 100vw;
    height: 100vh;
    height: calc(100 * var(--vh));
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    box-shadow: 0;
  ` : ``}


`;

export const MessageSkeleton = styled(Skeleton)<any>`
  border-radius: 7px;
  margin-bottom: 5px;
`;

export const LoadingChat = styled.div<{hasFooter: boolean, isExpanded: boolean, responsiveMode: boolean}>`
  padding-left: 40px;
  padding-right:8px;
  padding-top: 15px;

  @media ${DEVICE.mobile} {
    height: calc(100vh - 50px - ${props => props.hasFooter ? 90 : 0}px);
    height: calc(100 * var(--vh) - 50px - ${props => props.hasFooter ? 90 : 0}px);
  }

  ${props => props.isExpanded ? `
    height: calc(100vh - 50px - ${props.hasFooter ? 90 : 0}px);
    height: calc(100 * var(--vh) - 50px - ${props.hasFooter ? 90 : 0}px);
  ` : `` }

`;

export const StartMessages = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 10px;
`;

export const EndMessages = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;